/**
 * bootAfterLobby — Lobby bind + client polish + match loop (keeps app.js slim).
 */

import { bootLobbyAndMinimap } from './bootLobbyAndMinimap.js';
import { bindMatchEndPostGame } from './bindMatchEndPostGame.js';
import { wireAltarUnlock } from './wireAltarUnlock.js';
import { wireScoreboardHud } from './wireScoreboardHud.js';
import { bootClientPolish } from './bootClientPolish.js';
import { bootAppMatchLoop } from './bootAppMatchLoop.js';
import { ChampionMeshFactory } from '../factory/championMeshFactory.js';

/**
 * @param {object} deps
 */
export function bootAfterLobby(deps) {
  const {
    dom,
    scene,
    THREE,
    matchRuntime,
    mapObjectives,
    mapBounds,
    switchChampion,
    loadLiveMap,
    applyLobbySpells,
    championEntity,
    playerInventory,
    matchEndUi,
    matchOutcomeWire,
    entityInspect,
    activeMinions,
    activeProjectiles,
    activeJungleCamps,
    getBlueSpawner,
    getRedSpawner,
    wallBoxes,
    bushZones,
    impassableZones,
    recentDamageEvents,
    addMinionsToScene,
    MeshFactory,
    dummyEntity,
    tickSummonerSpells,
    abilityCasterVfx,
    mapSceneState,
    abilityCast,
    summonerSpellWire,
    inputController,
    onToggleRange,
    championGroup,
    hudUI,
    getRedTurretEntity,
    garenEntity,
    garenGroup,
    dummyPlateDiv,
    dummyHpBar,
    dummyGroup,
    getTurretRenderObjects,
    camera,
    renderer
  } = deps;

  const { minimap, tickMpPresence, lobbyController, lobbySession } =
    bootLobbyAndMinimap({
      rootEl: dom.minimapPanel,
      canvasEl: dom.minimapCanvas,
      matchRuntime,
      mapObjectives,
      mapBounds,
      switchChampion,
      loadLiveMap,
      applyLobbySpells,
      playerEntity: championEntity,
      playerInventory,
      mpPresenceDeps: {
        scene,
        THREE,
        createChampionMesh: (key, team) =>
          ChampionMeshFactory.createChampionMesh(key, team)
      }
    });

  bindMatchEndPostGame({
    matchEndUi,
    lobbyController,
    lobbySession,
    matchRuntime,
    loadLiveMap,
    switchChampion,
    applyLobbySpells
  });

  if (typeof window !== 'undefined') window.__mapObjectives = mapObjectives;
  wireAltarUnlock({ matchRuntime });

  const scoreboardWire = wireScoreboardHud({ matchRuntime });
  const { tickPingHud } = bootClientPolish({
    scoreboardWire,
    abilityCast,
    summonerSpellWire,
    inputController,
    onToggleRange
  });

  bootAppMatchLoop({
    THREE,
    camera,
    renderer,
    scene,
    inputController,
    matchRuntime,
    matchOutcomeWire,
    mapObjectives,
    entityInspect,
    minimap,
    activeMinions,
    activeProjectiles,
    activeJungleCamps,
    getBlueSpawner,
    getRedSpawner,
    mapBounds,
    wallBoxes,
    bushZones,
    impassableZones,
    recentDamageEvents,
    addMinionsToScene,
    MeshFactory,
    championEntity,
    dummyEntity,
    tickSummonerSpells,
    abilityCasterVfx,
    tickMpPresence,
    mapSceneState,
    tickPingHud,
    championGroup,
    dom,
    hudUI,
    getRedTurretEntity,
    garenEntity,
    garenGroup,
    dummyPlateDiv,
    dummyHpBar,
    dummyGroup,
    getTurretRenderObjects
  });

  return { minimap, lobbyController, lobbySession };
}
